const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/agentic-insights/experimental/briefing-4.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
import { defaultVariantSearchSchema } from '@/features/agentic-insights/components/experimental/variants/defaultVariant';
import { agenticInsightsBeforeLoad } from '../index';

/**
 * Briefing #4 — the variant being developed forward, and the one both the nav item's bare route and
 * `/experimental` default to (`defaultVariant.tsx`). Renders the exact same `DefaultVariantView` the
 * bare route does, so this address and the bare one can never quietly diverge into two
 * implementations of "the default" — this file exists only to give that same view its own,
 * separately-shareable URL, per the variants README.
 *
 * The permission check and flag gate are reused from the classic route: that is routing plumbing
 * rather than UI, and two copies would drift apart.
 */
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/agentic-insights/experimental/briefing-4')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: agenticInsightsBeforeLoad,
  validateSearch: search => defaultVariantSearchSchema.parse(search),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.agenticInsights.title)
    }
  }
});